const { actionCreators } = require("react/api/actions/modals");

Greenmile.RouteMonitor = Greenmile.RouteMonitor || {};
Greenmile.RouteMonitor.RightPanelEvents = (function () {

    var RouteMonitorRightPanelEvents = function () {

        this.page = 0;
        this.paginationToken = 0;
        this.criteria = null;
        this.equipmentField = null;
        this.eventTypeField = null;
        this.stopField = null;

        this.init = function () {

            this.DOMContainer = document.querySelector('.routeMonitorRightPanelBody');
            this.DOMContainer.innerHTML = '';
            this.DOMContainer.appendChild(this.createFormFilter());

            this.eventsContainer = document.createElement('div');
            this.eventsContainer.className = 'rightPanelBodyEventsContainer';

            this.eventsContainer.addEventListener('scroll', this.pagination.bind(this));

            this.DOMContainer.appendChild(this.eventsContainer);

        };

        this.createFormFilter = function () {

            var formFilterContainer = document.createElement('div');

            var formFilterTitle = document.createElement('div');
            var formFilterEquipment = document.createElement('div');
            var formFilterStop = document.createElement('div');
            var formFilterEvent = document.createElement('div');

            this.equipmentField = this.equipmentField || new Monet.UI.Fields.Render({
                    label: Monet.I18n.getResourcesByKey('equipment.userinterface.description'),
                    name: 'equipments',
                    mandatory: false,
                    type: 'LOOKUP',
                    lookupEntity: 'Equipment',
                    lookupEntityColumn: 'description'
                }, 'RouteMonitor').render();

            this.equipmentField.addListenerToAfterSelectRow((function (scope) {
                return function () {
                    scope.page = 0;
                    scope.getEvents();
                };
            }(this)));

            formFilterEquipment.appendChild(this.equipmentField.rootEl);

            this.stopField = this.stopField || new Monet.UI.Fields.Render({
                    label: Monet.I18n.getResourcesByKey('TaskManager.Tab.Event.Stop'),
                    name: 'stops',
                    mandatory: false,
                    type: 'LOOKUP',
                    lookupEntity: 'StopLookup',
                    lookupEntityColumn: 'location.key'
                }, 'RouteMonitor').render();

            this.stopField.addListenerToAfterSelectRow((function (scope) {
                return function () {
                    scope.page = 0;
                    scope.getEvents();
                };
            }(this)));

            formFilterEvent.appendChild(this.stopField.rootEl);

            this.eventTypeField = this.eventTypeField || new Monet.UI.Fields.Render({
                    label: Monet.I18n.getResourcesByKey('reportEvent.event'),
                    name: 'events',
                    mandatory: false,
                    type: 'LOOKUP',
                    lookupEntity: 'Event',
                    lookupEntityColumn: 'description'
                }, 'RouteMonitor').render();

            this.eventTypeField.addListenerToAfterSelectRow((function (scope) {
                return function () {
                    scope.page = 0;
                    scope.getEvents();
                };
            }(this)));

            formFilterEvent.appendChild(this.eventTypeField.rootEl);

            formFilterContainer.appendChild(formFilterTitle);
            formFilterContainer.appendChild(formFilterEquipment);
            formFilterContainer.appendChild(formFilterStop);
            formFilterContainer.appendChild(formFilterEvent);

            return formFilterContainer;

        };

        this.recreateEventLogCriteria = function () {

            var equipmentFieldValue = (this.equipmentField) ? this.equipmentField.getValue() : null;
            var eventTypeFieldValue = (this.eventTypeField) ? this.eventTypeField.getValue() : null;
            var stopFieldValue = (this.stopField) ? this.stopField.getValue() : null;

            var equipmentId = (equipmentFieldValue !== null) ? equipmentFieldValue.id : null;
            var eventTypeId = (eventTypeFieldValue !== null) ? eventTypeFieldValue.id : null;
            var stopId = (stopFieldValue !== null) ? stopFieldValue.id : null;

            this.criteria = {
                criteriaChain: [
                    {
                        and: [
                            {
                                attr: "closed",
                                eq: false
                            }
                        ]
                    }
                ],
                sort: [
                    {
                        attr: "timeValuedTrue",
                        type: "DESC"
                    }
                ]
            };

            if (equipmentId) {
                this.criteria.criteriaChain[0].and.push({
                    "attr": "equipment.id",
                    "eq": equipmentId
                });
            }

            if (eventTypeId) {
                this.criteria.criteriaChain[0].and.push({
                    "attr": "event.id",
                    "eq": eventTypeId
                });
            }

            if (stopId) {
                this.criteria.criteriaChain[0].and.push({
                    "attr": "stop.id",
                    "eq": stopId
                });
            }

        };

        this.createNoDataEventLine = function () {

            var line = document.createElement('div');
            line.innerHTML = Monet.I18n.getResourcesByKey('Greenmile.grid.showTotals.nothingData');
            line.className = 'eventsNoData';

            this.eventsContainer.innerHTML = '';
            this.eventsContainer.appendChild(line);

        };

        this.getEvents = function (firstResult, maxResults, callback) {

            var _firstResult = (typeof firstResult === 'undefined') ? this.page : firstResult;
            var _maxResults = (typeof maxResults === 'undefined') ? 51 : maxResults;

            this.recreateEventLogCriteria();

            var request = new Monet.Ajax();
            request.url = '/EventLog/restrictions?criteria={"filters":["*"], "firstResult":' + _firstResult + ',"maxResults":' + _maxResults + '}';
            request.method = 'POST';
            request.data = this.criteria;

            request.success = function (events) {

                if (events.length) {
                    if (!callback) {

                        this.updateEventList(events);
                        this.page += events.length;

                    } else {
                        callback(events);
                    }
                } else if (this.page === 0) {
                    this.createNoDataEventLine ();
                }

            }.bind(this);

            request.error = function () {
                return true;
            };

            request.send();

        };

        this.updateEventList = function (events) {
            if (this.page === 0) {
                this.eventsContainer.innerHTML = '';
                this.eventsContainer.appendChild(this.createEventsList(events));
            } else {
                this.eventsContainer.appendChild(this.createEventsList(events));
            }
        };

        this.createEventsList = function (events) {

            var fragment = document.createDocumentFragment();

            for (var i = 0, len = events.length; i < len; i++) {
                fragment.appendChild(this.createEventItem(events[i]));
            }

            return fragment;

        };

        this.createEventItem = function (event) {

            const eventItem = document.createElement('div');
            const eventDescription = document.createElement('div');
            const eventDate = document.createElement('div');

            eventItem.className = 'eventItem';
            eventDescription.className = 'eventDescription';
            eventDate.className = 'eventDate';

            eventItem.id = `routemonitor-evenitem-${event.id}`;

            eventItem.addEventListener('click', () => {
              window.globalStore.dispatch(actionCreators.openModal({
                modalKey: 'eventDetails',
                title: Monet.I18n.getResourcesByKey('eventDetails.modal.title'),
                data: {
                  eventLogId: event.id
                }
              }));
            });

            eventDescription.innerHTML = event.messageBody;
            eventDate.innerHTML = Monet.Format.DateTime.formatToLocale(event.timeValuedTrue);

            eventItem.appendChild(eventDescription);
            eventItem.appendChild(eventDate);

            return eventItem;

        };

        this.pagination = function () {

            var scrollArea = document.querySelector('.routeMonitorRightPanel .rightPanelBodyEventsContainer');
            var delta = scrollArea.scrollHeight - scrollArea.scrollTop - scrollArea.getBoundingClientRect().height;

            clearTimeout(this.paginationToken);

            if (delta < 20) {
                this.paginationToken = setTimeout(function () {

                    this.getEvents();

                }.bind(this), 400);
            }

        };

        this.getCurrentPageByScroll = function () {

            var scrollArea = document.querySelector('.routeMonitorRightPanel .rightPanelBodyEventsContainer');
            var initialPage = Math.round(scrollArea.scrollTop / 54);
            var pageSize = Math.round(scrollArea.getBoundingClientRect().height / 54);

            return {
                firstResult: initialPage,
                maxResults: pageSize
            };
        };

    };

    return RouteMonitorRightPanelEvents;

}());
